import { defineStore } from "pinia";
import { useCurrentRawExperienceQuery } from "@/features/experience-raw/composables/useCurrentRawExperienceQuery";
import { useRawExperienceReadonly } from "@/features/experience-raw/composables/useRawExperienceReadonly";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";
import { useIsVoucherInfoVisible } from "@/features/experience-shared/composables/useIsVoucherInfoVisible";

export const useRawCustomerVoucherInfo = defineStore("raw-customer-info-voucher-field", () => {
  const { data: experienceRaw } = useCurrentRawExperienceQuery();

  const initialValue = computed(() => experienceRaw.value?.commercial?.info_voucher ?? "");

  const { model, hasChanges, reset, isFilled } = usePrimitiveModelWithChanges(initialValue);

  const { isReadonly } = useRawExperienceReadonly();
  const isRequired = false;
  const isVisible = useIsVoucherInfoVisible();

  return {
    id: "info_voucher",
    model,
    isReadonly,
    isDisabled: false,
    isRequired,
    isVisible,
    isFilled,
    hasChanges,
    $reset: reset,
  };
});
